export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_incentiva.png",
      alt: "Nome da extensão",
    },
    title: "Opere com as estratégias da Incentiva Negócios",
    text: [
      "Com mais de 15 anos de experiência em renda variável e desenvolvimento de indicadores, automações e metodologia operacional para o mercado global. Nossas estratégias são exclusivas e feita para ajudar a diversificar o seu portfólio de investimentos.",
    ],
    testimonial: {
      text: "Tecnologia, estabilidade e performance é o que nos move.",
      author: {
        name: "Evandro Soares",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Alguns números da Incentiva Negócios",
    subtitle: "Mais de 15 anos de experiência em desenvolvimento de estratégias automatizadas",
    data: [
      {
        value: "+15",
        description: "Anos de atividade",
      },
      {
        value: "+1500",
        description: "Clientes",
      },
      {
        value: "+1M",
        description: "De ordens executadas ao ano",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Incentiva Negócios?",
    subtitle: "Veja quais as principais vantagens dos robôs da Incentiva Negócios.",
    data: [
      {
        title: "Velocidade",
        description:
          "Nossos algoritmos realizam milhares de cálculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        title: "Ganhe tempo",
        description:
          "Escolha suas estratégias e deixe que a plataforma opere por você. Não é necessário acompanhar o mercado o tempo todo.",
      },
      {
        title: "Sem emocional",
        description: "Com estratégias automatizadas, você elimina decisões impulsivas e irracionais nos investimentos.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Incentiva Negócios.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Incentiva Negócios",
    col1: [
      "Uma empresa de tecnologia e desenvolvimento de estratégias para o mercado financeiro. Na Incentiva toda a nossa equipe de desenvolvimento está sempre aprimorando as estratégias para que elas estejam sempre de acordo com a volatilidade do mercado e também esteja ajustada para os ativos que serão operadas individualmente ou em uma cesta de ativos. ",
      "Nossos algoritmos são proprietários e cuidadosamente ajustado para o mercado brasileiro e para os ativos negociados na B3. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Incentiva Negócios",
  },
  strategies: {
    title: "Estratégias Incentiva Negócios",
    heading: "Algoritmos avançados à sua disposição",
    subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: "Estou gostando muito de usar a automação da incentiva justamente por tirar o peso do emocional e a segurança do gerenciamento financeiro.",
      author: "Marcelo dos Santos",
      job: "Advogado",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Ter uma automação seguidora de tendência com uma gestão de número de entradas e controle do risco, para mim é a melhor condição, para ter bons resultados.",
      author: "Pedro Correa",
      job: "Engenheiro",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
